
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Mail from '@/extend/classes/Mail';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeMail' })

export default class storeMail extends VuexModule {
  // States
  private reccords: Mail[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get mailLoading (): boolean {
    return this.dataLoading;
  }
  private get mailRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get mailLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewMail() {
    return (): Mail => { 
      return this.getMail(0, true);
    }
  }

  
  public get getMail () {
    return (id: number, canCreate = false): Mail => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Mail can't be 0")
        return new Mail();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Mail();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Mail.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromMail(data.reccords[0] as Mail);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listMail (): Mail[] {
    return this.reccords;
  }

  public get listConfigMail (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mMailRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mMailClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mMailLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mMailLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Mail.fromJson(reccord as Mail));
    })
    Mail.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mMailConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mMailCreated (obj: Mail): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareMail(obj)) {
          api.fromMail(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareMail(obj)) {
            api.fromMail(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mMailUpdated (obj: Mail): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareMail(obj)) {
          api.fromMail(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mMailDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerMail (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.mailRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerMail(this.mailCreated, this.mailUpdated, this.mailDeleted);
          this.mMailRegistered();
        } else {
          setTimeout(() => resolve(this.registerMail(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.mailLoading && !this.mailLoaded) {
          this.mMailLoading(true);
          return Mail.list(filter)
            .then((data: ListData) => {
              this.mMailLoaded(data);
              this.mMailLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredMail (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.mailLoading) {
        this.mMailLoading(true);
        return Mail.list(filter)
          .then((data: ListData) => {
            this.mMailLoaded(data);
            this.mMailLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createMail (obj: Mail): Promise<Mail> {
    return new Promise((resolve, reject) => {
      return Mail.fromJson(obj).createForStoreMail()
        .then((reccords) => {
          this.mMailCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateMail (obj: Mail): Promise<Mail> {
    return new Promise((resolve, reject) => {
      return Mail.fromJson(obj).updateForStoreMail()
        .then((reccords) => {
          this.mMailUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteMail (obj: Mail): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Mail.fromJson(obj).deleteForStoreMail()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mMailDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private mailCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mMailConfigUpdated(config)
    const obj = objConfig.obj as Mail;
    this.mMailCreated(Mail.fromJson(obj));
  }

  @Action
  private mailUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mMailConfigUpdated(config)
    const obj = objConfig.obj as Mail;
    this.mMailUpdated(Mail.fromJson(obj));
  }

  @Action
  private mailDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Mail;
    this.mMailDeleted(obj.id);
  }
}
